// eslint-disable-next-line @typescript-eslint/no-unused-vars
import axios from "axios";
import {BASE_URL} from "./env";

interface AxiosProps {
  URL: string;
  method: "GET" | "POST" | "PUT" | "DELETE" | "PATCH";
  data?: any;
  headers?: any;
  authorize?: boolean;
  isDev?: boolean;
}

const useAxios = ({
  URL,
  method = "GET",
  data = {},
  headers = {},
  authorize = false,
  isDev = false,
}: AxiosProps) => {
  // Get user token
  const token = localStorage.getItem("user_token");
  if (token) {
    headers.Authorization = "bearer " + token;
  }
  let baseUrl = BASE_URL + URL;
  const res = (async () => {
    if (baseUrl) {
      try {
        const config: any = {
          method: method,
          url: baseUrl,
          headers,
        };
        config.data = data;
        return await axios(config);
      } catch (e: any) {
        if (e.response.data.detail === "Could not validate credentials") {
          localStorage.removeItem("user_token");
          window.location.href = "/login";
        } else {
          throw e;
        }
      }
    }
  })();
  return res;
};
export default useAxios;
